Array.from(document.getElementsByClassName('min-select')).forEach(minSelect => {
    const maxSelect = document.getElementById(minSelect.dataset.maxSelectId)
    minSelect.addEventListener('change', evt => {
        const minValue = evt.target.value
        if (maxSelect.value < minValue) {
            maxSelect.value = ''
        }
        Array.from(maxSelect.getElementsByTagName('option')).forEach(option => {
            option.disabled = option.value && option.value < minValue ? 'disabled' : null
        })
    })
})
